module.exports = __webpack_public_path__ + "images/emoji/heavy_minus_sign.11d6c9edf517e627646e.png";